/* eslint-disable no-restricted-imports */
"use client";

import { FlatNamespace, KeyPrefix, TFunction, TOptions } from "i18next";
import {
  i18n,
  Trans as TransNext,
  useTranslation as useTranslationNext,
} from "next-i18next";
import { FallbackNs, UseTranslationResponse } from "react-i18next";

export type Translate = TFunction;

export const useLanguage = () => {
  const { i18n } = useTranslationNext();
  return i18n.language;
};

export function useTranslation<
  Ns extends FlatNamespace,
  KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined,
>(
  ns?: Ns,
  otherOptions: { keyPrefix?: KPrefix } = {},
): UseTranslationResponse<FallbackNs<Ns>, KPrefix> {
  const { t: originalT, ...rest } = useTranslationNext(ns, otherOptions);

  const t = ((key: string, options?: TOptions) => {
    const allOptions = { ...otherOptions, ...options };
    const translationKey = key.includes(":") ? key : `${ns}:${key}`;
    if (!allOptions.defaultValue && !i18n?.exists(translationKey, allOptions)) {
      // captureMessage(`Missing translation: ${translationKey}`, Severity.Error);
    }
    return originalT(translationKey, allOptions);
  }) as TFunction;
  return { t, ...rest };
}

export const Trans: React.FC<{
  i18nKey: string;
  count?: number;
  values?: NonNullable<unknown>;
  defaults?: string;
  components?:
    | readonly React.ReactElement[]
    | { readonly [tagName: string]: React.ReactElement };
}> = ({ i18nKey, components, values, count, defaults }) => {
  const { t } = useTranslation();
  return (
    <TransNext
      t={t}
      defaults={defaults}
      i18nKey={i18nKey}
      count={count}
      values={values}
      components={components}
    />
  );
};
